import React from "react";
import EducationItem from "./EducationItem";

function EducationList({educations, onEdit, onDelete}) {
    return (
        <div>
            {educations.length > 0 ? (
              <div className="row row-cols-2 mt-2">
                {educations.map((education) => (
                   <div className="col-6" key={education.id}>
                    <EducationItem
                        education={education}
                        onEdit={() => onEdit(education)}
                        onDelete={() => onDelete(education.id)}
                    />
                    </div>
                ))}
                </div>
            ) : (
                <div className="text-center">
                    <h4>No Educations</h4>
                    <p className="text-muted small">No educations added yet. Add your education to build your CV.</p>
                </div>
            )}
        </div>
    );
}

export default EducationList;
